import { makeVar, useReactiveVar } from "@apollo/client"
import type {
  ItemType,
  ThresholdType,
  GwpModuleType,
  ExperimentTrackingType,
  BasketUpdateResultType,
} from "types"

export type BasketType = {
  gwpModule: GwpModuleType | null
  thresholds: ThresholdType[] | null
  items: ItemType[]
  experiments: ExperimentTrackingType[] | null
  isBasketV2: BasketUpdateResultType["isBasketV2"]
}

const initialBasket: BasketType = {
  gwpModule: null,
  thresholds: [],
  items: [],
  experiments: [],
  isBasketV2: false,
}

const basket = makeVar<BasketType>(initialBasket)

export const useBasket = (): BasketType => useReactiveVar(basket)

export const setBasket = (data?: Partial<BasketType>): BasketType => {
  if (!data) return basket()

  return basket({ ...basket(), ...data })
}

export const resetBasket = (): BasketType => {
  return basket(initialBasket)
}
